<div
  (dragover)="$event.preventDefault()"
  (dragenter)="$event.preventDefault()"
  (drop)="onDropped($event)"
  (click)="!disabled() && fileInput.click()"
  (keydown)="onKeydown($event, fileInput)"
  class="dropzone"
  [attr.aria-disabled]="disabled()"
  [attr.tabindex]="disabled() ? -1 : 0"
>
  <ng-content></ng-content>
  Sélectionnez ou déposez vos fichiers ici
  <input
    #fileInput
    type="file"
    [multiple]="multiple()"
    [accept]="allowedTypes()"
    [disabled]="disabled()"
    (change)="onSelected($event)"
  />
</div>
